<script setup lang="ts">
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/Card';

import { Separator } from '@/components/ui/Separator';

import type { HTMLAttributes } from 'vue';

defineProps<{
  contentClass?: HTMLAttributes['class'];
  footerClass?: HTMLAttributes['class'];
  cardTitle?: string;
  cardDescription?: string;
  hasFooter?: boolean;
  hasHeaderSeparator?: boolean;
}>();
</script>

<template>
  <Card :data-testid="`card-wrapper-${cardTitle}`">
    <CardHeader>
      <CardTitle
        v-if="cardTitle"
        :class="hasHeaderSeparator && 'font-medium'"
        data-testid="card-title"
      >
        {{ cardTitle }}
      </CardTitle>
      <Separator v-if="hasHeaderSeparator" data-testid="card-separator" />
      <CardDescription v-if="cardDescription" data-testid="card-description">
        {{ cardDescription }}
      </CardDescription>
    </CardHeader>
    <CardContent :class="contentClass" data-testid="card-content">
      <slot name="card-content"></slot>
    </CardContent>
    <CardFooter v-if="hasFooter" :class="footerClass" data-testid="card-footer">
      <slot name="card-footer"></slot>
    </CardFooter>
  </Card>
</template>
